.summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-font-size-3);
}

.score {
  margin: 0;
  font-size: var(--tuna-font-size-5);
  font-weight: 700;
}

.breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin: 0;
  width: 100%;
  max-width: 320px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.rowLabel,
.rowValue {
  margin: 0;
  font-size: var(--tuna-font-size-1);
}

.footer {
  margin: 0;
  max-width: 420px;
  font-size: var(--tuna-font-size-1);
  color: var(--tuna-color-text-subtle);
}

.cta {
  padding: var(--tuna-spacing-2) var(--tuna-spacing-4);
  font-weight: 600;
}
